<template>
  <div :style="`height:${cell.height}px`" class="ud-html-cell" v-html="htmlContent" />
</template>

<script>
import common from '@/mixins/common';
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  mixins: [common],
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data() {
    return {
      htmlContent: null,
    };
  },
  created() {
    this.loadHtmlContent();
  },
  computed: {
    ...mapState('language', ['selectedLang']),
  },
  methods: {
    loadHtmlContent() {
      if (this.cell.html.indexOf('&lt;') >= 0) {
        this.htmlContent = this.cell.html.replaceAll('&gt;', '>').replaceAll('&lt;', '<').replaceAll('&quot;', '"');
      } else {
        let htmlName = this.cell.html;
        // to support translation of included html, the name of the file is pre-postfixed with ${lang}.html, e.g
        // the german file is named ud-config.hilfestellung.html and the english file is named ud-config.hilfestellung.en.html
        if (this.selectedLang !== 'de') {
          htmlName = htmlName.replace('.html', `.${this.selectedLang}.html`);
        }
        axios.get(this.assetUrl(htmlName)).then((res) => (this.htmlContent = res.data));
      }
    },
  },
  watch: {
    cell() {
      this.loadHtmlContent();
    },
    selectedLang(newValue, oldValue) {
      console.debug('newValue', newValue);
      this.loadHtmlContent();
    },
  },
};
</script>
